((SortBar, $) => {
  'use strict';
  let $sortingBar;
  let $sortingMenu;
  let $activate;
  let $sortList;
  let $sortItems;
  let $sidebar;
  let $sortingMethod;
  let $shopTitle;

  const cacheDom = () => {
    $sortingBar = $('.js-sorting-bar');
    $sortingMenu = $('.js-sort-menu');
    $activate = $('.js-sort-bar-activate');
    $sortList = $sortingMenu.find('.js-sort-bar-list');
    $sortItems = $sortingMenu.find('.js-sort-bar-item');
    $sidebar = $('.js-star-sidebar');
    $sortingMethod = $('.js-sorting-method');
    $shopTitle = $('.js-shop-title');
  };

  const scroll = () => {
    let addOn = $('.main-navigation').height();
    $('html, body').animate({
      scrollTop: $sortingBar.offset().top - addOn
    });
  };

  const rotate = ($item, rotateClass) => {
    if ($item.hasClass(rotateClass)) {
      $item.removeClass(rotateClass);
    } else {
      $item.addClass(rotateClass);
    }
  };

  const setActive = () => {
    const queries = window.location.search.slice(1, window.location.search.length).split('&');
    const queryObj = {};
    const activeClass = 'active';
    for (let i = 0; i < queries.length; i++) {
      let queryArray = queries[i].split('=');
      queryObj[queryArray[0]] = queryArray[1];
    }
    $sortItems.removeClass(activeClass).each(function () {
      const $this = $(this);
      if ($this.attr('data-search') === queryObj.sort_by) {
        $this.addClass(activeClass);
        $sortingMethod.text($this.text());
      }
    });

    if (!$sortItems.hasClass(activeClass)) {
      $($sortItems[0]).addClass(activeClass);
      $sortingMethod.text($($sortItems[0]).text());
    }
  };

  const bindUIActions = () => {
    $activate.on('click', function( ) {
      const $this = $(this);
      if ($(window).width() < 992) {
        scroll();
        $sidebar.hide();
      }
      $('.js-star-filtering .js-sorting-caret').removeClass('sorting-caret--rotate');
      $shopTitle.removeClass('active');
      rotate($this.find('.js-sorting-caret'), 'sorting-caret--rotate');
      $sortList.slideToggle();
      $sortingMethod.toggleClass('active');
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
    setActive();
  };

  SortBar.init = init;
  SortBar.scroll = scroll;
  SortBar.rotate = rotate;
})(window.SortBar = window.SortBar || {}, jQuery);
